/**
 * Status values for data-fetching hooks.
 *
 * Used as the `*Status` field in any hook that performs async loading
 * (e.g. `productsStatus`, `configStatus`). Consumers switch on these values
 * to render loading, error, and ready states.
 */
export const FETCH_STATUS = {
  LOADING: 'loading',
  READY:   'ready',
  ERROR:   'error',
  DISABLED: 'disabled',
}
